import { render, staticRenderFns } from "./GramEvent.vue?vue&type=template&id=0fe527ca"
import script from "./GramEvent.vue?vue&type=script&lang=ts"
export * from "./GramEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports